var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.blocks),function(block,index){return _c(_vm.contentBlockComponentsMap[block.type],_vm._b({key:index,tag:"Component"},'Component',{ block },false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }